import React, { useEffect } from "react";
import useStore from "../../useStore";
import Loader from "../Elements/Loader/Loader";
import { useToast } from "../../Contexts/Toast/toast.provider";
import { Link } from "react-router-dom";
import "./home.css";

const Home = () => {
  const { users, loading, error, fetchUsersData } = useStore();
  const showToast = useToast();
  // 1) Al montar, disparar fetchUsersData()
  useEffect(() => {
    fetchUsersData();
  }, [fetchUsersData]);
  // 2) Si ocurre un error global al traer usuarios, mostrar toast
  useEffect(() => {
    if (error) {
      showToast("error", "Error al cargar usuarios");
    }
  }, [error, showToast]);
  // 3) Mientras loading=true mostramos Loader
  if (loading) {
    return <Loader />;
  }
  // 4) Ordeno alfabéticamente por username
  const sortedUsers = Array.isArray(users)
    ? [...users].sort((a, b) =>
      a.username.localeCompare(b.username, undefined, { sensitivity: "base" })
    )
    : [];

  return (
    <div className="container container-routes-see container-home py-4">
      <div className="row">
        <div className="col-12">
          <h2>Hola👋</h2>
          <p className="mt-2">¿De quién quieres ver las rutas?</p>
          {sortedUsers.length > 0 ? (
            <ul className="list-group mt-4">
              {/* Fila de cabeceras */}
              <li className="list-group-item d-flex bg-light">
                <div className="col-6">
                  <strong>Usuario</strong>
                </div>
                <div className="col-6 text-end">
                  <strong>Creado</strong>
                </div>
              </li>
              {/* Filas de datos */}
              {sortedUsers.map((user) => (
                <li
                  key={user.username}
                  className="list-group-item list-group-item-action d-flex"
                >
                  <Link
                    to={`/usuario/${user.username}`}
                    reloadDocument
                    className="d-flex w-100"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <div className="col-6">{user.username}</div>
                    <div className="col-6 text-end text-muted">
                      {new Date(user.createdAt).toLocaleString(undefined, {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                      })}
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <p>No se encontraron usuarios.</p>
          )}
        </div>
      </div>
      <Link to="/adduser" className="btn-flotante">
        Agregar usuario
      </Link>
    </div>
  );
};

export default Home;
